import axios from 'axios';
import { CURRENT_API_URL } from "../../../../Utils/Constants";
import notify from '../../../../Notifications/ToastifyActions';

function UpdateCatalogForStoreService(token, data ) {
    return axios.post(`${CURRENT_API_URL}/sellerPartner/updateCatalogForStore`, data,{
        headers: {
            'Authorization': token,
        }
        }).then(res => {
            notify.NotifySuccess(res.data);       
            return res.data;        
        }).catch(error => {
            console.log(error);
            notify.NotifyError("An error occurred while fetchig catalog items. please try again later.");
            return false;
        });
    }

export default UpdateCatalogForStoreService;